// Coups de coeur : liste de handles gardee sur l'appareil (localStorage), meme si le client est connecte.
(() => {
  const KEY = 'charms-favoris';
  const ADD = 'Ajouter aux coups de cœur';
  const DEL = 'Retirer des coups de cœur';
  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch (e) { return []; }
  };
  let list = read();

  function sync() {
    document.querySelectorAll('[data-wishlist]').forEach((btn) => {
      const on = list.includes(btn.dataset.wishlist);
      btn.setAttribute('aria-pressed', on);
      btn.setAttribute('aria-label', on ? DEL : ADD);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = !list.length;
    });
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { list } }));
  }

  function set(next) {
    list = next;
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* stockage bloque : reste valable jusqu'au rechargement */ }
    sync();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const h = btn.dataset.wishlist;
    const adding = !list.includes(h);
    set(adding ? [...list, h] : list.filter((x) => x !== h));
    if (adding) {
      document.querySelectorAll('[data-wishlist="' + CSS.escape(h) + '"]').forEach((b) => {
        b.classList.remove('is-pop');
        void b.offsetWidth;
        b.classList.add('is-pop');
      });
    }
  });

  document.addEventListener('animationend', (e) => e.target.classList?.remove('is-pop'));
  document.addEventListener('coll:updated', sync);
  window.addEventListener('storage', (e) => { if (e.key === KEY) { list = read(); sync(); } });

  window.charmsWishlist = { get: () => list.slice(), remove: (h) => set(list.filter((x) => x !== h)) };
  sync();
})();
